import './keyword.js.coffee';# Added by Script 
class Monitoring.Collections.SortableKeywordsCollection extends Monitoring.Collections.KeywordsCollection
  updateOrder: (orderedNames) ->
    order = 0
    _.each orderedNames, (name) =>
      @findWhere(name: name).set('order', order)
      order += 1
